import qs from 'qs'
import request, { getExcel } from '@/utils/request'
import {
  ConfirmReturnManagementReq,
  ConfirmReturnManagementRes,
  DownloadReturnManagementReq,
  GetReturnManagementReq,
  OrderSearchItemRes,
  OrderSearchReq,
  ReturnManagementItemRes,
  SaveReturnManagementReq,
  SaveReturnManagementRes,
} from './types'

/**
 * RGR04 반품관리 엔드포인트. 1.0 `/api/grid/*`(MENU_CD=RGR04_HEAD)의 2.0 이관(계획서 2장·3장).
 *
 * | 동작 | 2.0 API |
 * |---|---|
 * | 조회 | `GET /api/v1/return/management` |
 * | 저장 | `POST /api/v1/return/management/save` |
 * | 확정 | `POST /api/v1/return/management/confirm` |
 * | 엑셀 다운로드 | `POST /api/v1/return/management/download` |
 * | 주문검색 팝업 | `GET /api/v1/return/management/order-search` |
 *
 * 서버 페이징이 없다 — 조건에 걸린 전건이 한 번에 온다.
 */
export const RETURN_MANAGEMENT_URL = '/api/v1/return/management'
export const RETURN_MANAGEMENT_SAVE_URL = '/api/v1/return/management/save'
export const RETURN_MANAGEMENT_CONFIRM_URL = '/api/v1/return/management/confirm'
export const RETURN_MANAGEMENT_DOWNLOAD_URL = '/api/v1/return/management/download'
export const RETURN_MANAGEMENT_ORDER_SEARCH_URL = '/api/v1/return/management/order-search'

/** 빈 문자열은 조건에서 뺀다 — 그대로 보내면 완전일치 조건이 빈 문자열과 비교돼 무결과가 된다. */
const toQuery = <T extends object>(params: T): string =>
  qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true, filter: (_, value) => (value === '' ? undefined : value) })

export const getReturnManagements = (params: GetReturnManagementReq) =>
  request.get<ApiResponseV2<{ items: ReturnManagementItemRes[] }>>(`${RETURN_MANAGEMENT_URL}?${toQuery(params)}`)

export const saveReturnManagements = (body: SaveReturnManagementReq) =>
  request.post<ApiResponseV2<SaveReturnManagementRes>, SaveReturnManagementReq>(RETURN_MANAGEMENT_SAVE_URL, body)

export const confirmReturnManagements = (body: ConfirmReturnManagementReq) =>
  request.post<ApiResponseV2<ConfirmReturnManagementRes>, ConfirmReturnManagementReq>(RETURN_MANAGEMENT_CONFIRM_URL, body)

/**
 * 엑셀 다운로드 — 응답이 암호 zip 바이트다(3.4). blob 을 그대로 돌려주고 파일명·저장은 호출부가 한다
 * (기본 파일명 폴백을 `.zip` 으로 둬야 해서 공용 `useDownloadExcel`(기본 `.xlsx` 폴백)을 쓰지 않는다).
 */
export const downloadReturnManagements = (body: DownloadReturnManagementReq) =>
  getExcel(RETURN_MANAGEMENT_DOWNLOAD_URL, { method: 'post', data: body })

export const searchReturnOrders = (params: OrderSearchReq) =>
  request.get<ApiResponseV2<{ items: OrderSearchItemRes[] }>>(`${RETURN_MANAGEMENT_ORDER_SEARCH_URL}?${toQuery(params)}`)
